import { Component, OnInit } from '@angular/core';
import { IconService } from './services/icon/icon.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(){}

  ngOnInit(): void {
  }


  title = 'app';
}
